<div class="container_wrapper--summary-data">
  <div class="center_main--summary-data">
    <app-common-wrapper
      [extraExercise]="summaryData?.lesson_extra_exercise"
    ></app-common-wrapper>
    <ng-container *ngIf="!allAbsent">
      <div>
        <table class="summary-table--summary-data">
          <thead class="table_header--summary-data">
          <tr>
            <th class="row_header--summary-data"></th>
            <th *ngFor="let box_data of boxes;" class="box_level--summary-data">
              <span class="box_number">
                box {{ box_data.box.title }}
              </span>
              <div class="box_level" [class.is_extra_exercise]="checkBoxForExtraExercise(box_data.box)">
                {{ box_data.box.level }}
              </div>
            </th>
            <th></th>
          </tr>
          <tr>
            <th class="row_header--summary-data edit_content--summary-data">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="cls-3-edit-rows" 
                  (click)="openTableSelectRowsDialog(summaryDataModal);">
                  <defs>
                    <style>.cls-1-edit-rows{fill:none;}.cls-2-edit-rows{fill:#8dceb3;}.cls-3-edit-rows:hover{cursor:pointer;}.cls-3-edit-rows:hover .cls-2-edit-rows{fill:#4fad93;}</style>
                  </defs>
                  <title>Редактировать строки таблицы</title>
                  <g id="Слой_2" data-name="Слой 2">
                    <g id="Слой_8" data-name="Слой 8">
                      <rect class="cls-1-edit-rows" width="16" height="16"/>
                      <path class="cls-2-edit-rows" d="M12,8v4a2,2,0,0,1-2,2H2V4H9l1-1H1V15h9a3,3,0,0,0,3-3V7Z"/>
                      <path class="cls-2-edit-rows" d="M14.81,1.8l-.1-.1a1,1,0,0,0-1.41,0L13,2l1.5,1.5.31-.28A1,1,0,0,0,14.81,1.8Z"/>
                      <polygon class="cls-2-edit-rows" points="6.77 8.23 5 11.5 8.27 9.73 7.49 8.95 6.77 8.23 6.77 8.23"/>
                      <polygon class="cls-2-edit-rows" points="7.47 7.53 8.22 8.28 8.97 9.03 13.77 4.23 12.27 2.73 7.47 7.53"/>
                    </g>
                  </g>
                </svg>
                <ng-template
                  class="modal fade in"
                  data-backdrop="false"
                  #summaryDataModal>
                  <div class="modal-body" style="padding: 0">
                    <app-individual-or-summary-data-modal
                    [data]="selectedTableRows"
                    [summaryOrIndividual]="'summary'"
                    (choseTableRows)="choseIndividualDataTableRows($event)"
                    (closeBtnClicked)="closeIndividualDataModal()"
                    ></app-individual-or-summary-data-modal>
                  </div>
                </ng-template>
              </span>
            </th>
            <th *ngFor="let box_data of boxes;" class="box_name--summary-data">
              <div class="box_bgr--summary-data">
                <div class="box_files--summary-data">
                <span *ngFor="let file of box_data.box.files">
                  {{ file.str_title }}
                </span>
                </div>
              </div>
            </th>
            <th class="total--summary-data">Всего</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of selectedTableRows;">
            <td class="row_header--summary-data"
                [ngClass]='{
                    "right_amount--summary-data": row === "tasksSolved",
                    "percent_error--summary-data": row === "errors",
                    "success_students--summary-data": row === "successStudents",
                    "money_amount--summary-data": row === "earned"
                  }'>
              {{getRowName(row)}}
            </td>
            <td *ngFor="let box of boxes;" class="table_cell--summary-data">
              <div *ngIf="row === 'variantsSolved'" [ngClass]='{ "best--summary-data": box.has_max_correct_cards }'>
                {{ getData(box?.formating_data_cards) }}
              </div>
              <div *ngIf="row === 'tasksSolved'" [ngClass]='{ "best--summary-data": box.has_max_correct_exercises }'>
                {{ getData(box?.fromating_data_exercises) }}
              </div>
              <div *ngIf="row === 'averageSolveAmount'">
                {{ getData(box?.average_solved_by_pupil) }}
              </div>
              <div *ngIf="row === 'errors'" class="percent_error--summary-data">
                {{ getData(box?.average_error_percent) }}
              </div>
              <div *ngIf="row === 'solveAmount'">
                {{ getData(box?.total_pupil_solved_box) }}
              </div>
              <div *ngIf="row == 'extra_exercises'">
                {{ getData(box?.extra_exercise?.formating_data_extra_exercises) }}</div>
              <div *ngIf="row === 'successStudents'" class="success_level--summary-data">
                {{ getData(box?.number_of_successfull_pupil) }}
              </div>
              <div *ngIf="row === 'earned'" class="money_amount--summary-data">
                {{ getMoneyAmountData(box?.box_amount) }}
              </div>
            </td>
            <td class="table_cell--summary-data total--summary-data">
              <div *ngIf="row === 'variantsSolved'">
                {{ getData(summaryData?.lesson_stat?.formating_data_cards) }}
              </div>
              <div *ngIf="row === 'tasksSolved'">
                {{ getData(summaryData?.lesson_stat?.formating_data_exercises) }}
              </div>
              <div *ngIf="row === 'averageSolveAmount'">
                {{ getData(summaryData?.lesson_stat?.average_solved_by_one_pupil) }}
              </div>
              <div *ngIf="row === 'errors'" class="percent_error--summary-data">
                {{ getData(summaryData?.lesson_stat?.average_error_percent) }}
              </div>
              <div *ngIf="row === 'solveAmount'">
                {{ getData(summaryData?.lesson_stat?.number_of_decision_students) }}
              </div>
              <div *ngIf="row == 'extra_exercises'">
                  {{ getData(summaryData?.lesson_extra_exercise?.formating_data) }}</div>
              <div *ngIf="row === 'successStudents'">
                <div *ngIf="summaryData.lesson_stat">
                  {{ getData(summaryData?.lesson_stat?.number_of_successfull_students) }}
                </div>
              </div>
              <div *ngIf="row === 'earned' && summaryData.lesson_amount_stat != null" class="money_amount--summary-data">
                {{ getMoneyAmountData(summaryData?.lesson_amount_stat?.total_currencies_amount) }}
              </div>
              <div *ngIf="row === 'earned' && summaryData.lesson_amount_stat == null" class="money_amount--summary-data">
                0
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class='graphs graphs_inline-block graphs_margin-top'>
        <google-chart *ngIf='resolveSpeedGraphData' #rsChart
          (chartReady)='onChartReady(rsChart)'
          [title]="resolveSpeedGraphData.title"
          [type]="resolveSpeedGraphData.chartType"
          [data]="resolveSpeedGraphData.dataTable"
          [columnNames]="resolveSpeedGraphLabels"
          [options]="resolveSpeedGraphData.options">
        </google-chart>
        <google-chart *ngIf='errorPercentGraphData' #epChart
          (chartReady)='onChartReady(epChart)'
          [title]="errorPercentGraphData.title"
          [type]="errorPercentGraphData.chartType"
          [data]="errorPercentGraphData.dataTable"
          [columnNames]="errorPercentGraphLabels"
          [options]="errorPercentGraphData.options">
        </google-chart>
        <google-chart *ngIf='averageCurrenciesGraphData' #acChart
          (chartReady)='onChartReady(acChart)'
          [title]="averageCurrenciesGraphData.title"
          [type]="averageCurrenciesGraphData.chartType"
          [data]="averageCurrenciesGraphData.dataTable"
          [columnNames]="averageCurrenciesGraphLabels"
          [options]="averageCurrenciesGraphData.options">
        </google-chart>
      </div>
      <div class='graphs graphs_border graphs_flex'>
        <google-chart *ngIf='filesGraphData' #filesChart
                      (chartReady)='onChartReady(filesChart)'
                      [title]="filesGraphData.title"
                      [type]="filesGraphData.chartType"
                      [data]="filesGraphData.dataTable"
                      [columnNames]="filesGraphLabels"
                      [options]="filesGraphData.options">
        </google-chart>
        <div class='google-chart-placeholder' *ngIf='!filesGraphData'></div>
        <div class='graphs--selected-subjects'>
          <div class='graphs--selected-subjects-title graphs-selected-subject_margin-bottom'>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="cls-3-edit-subjects" 
              (click)="openTableSubjectsDialog(summaryModal);">
              <defs>
                <style>.cls-1-edit-subjects{fill:none;}.cls-2-edit-subjects{fill:#8dceb3;}.cls-3-edit-subjects:hover{cursor:pointer;}.cls-3-edit-subjects:hover .cls-2-edit-subjects{fill:#4fad93;}</style>
              </defs>
              <title>Редактировать список подтем</title>
              <g>
                <g>
                  <rect class="cls-1-edit-subjects" width="16" height="16"/>
                  <path class="cls-2-edit-subjects" d="M12,8v4a2,2,0,0,1-2,2H2V4H9l1-1H1V15h9a3,3,0,0,0,3-3V7Z"/>
                  <path class="cls-2-edit-subjects" d="M14.81,1.8l-.1-.1a1,1,0,0,0-1.41,0L13,2l1.5,1.5.31-.28A1,1,0,0,0,14.81,1.8Z"/>
                  <polygon class="cls-2-edit-subjects" points="6.77 8.23 5 11.5 8.27 9.73 7.49 8.95 6.77 8.23 6.77 8.23"/>
                  <polygon class="cls-2-edit-subjects" points="7.47 7.53 8.22 8.28 8.97 9.03 13.77 4.23 12.27 2.73 7.47 7.53"/>
                </g>
              </g>
            </svg>
            <ng-template
                class="modal fade in"
                data-backdrop="false"
                #summaryModal>
                <div class="modal-body">
                  <app-summary-modal
                    [selectedFiles]="selectedFiles"
                    [themes]="themes"
                    [files]="files"
                    (closeBtnClicked)="closeIndividualDataModal()"
                    (setSelectedFiles)="setSelectedFiles($event)"
                  ></app-summary-modal>
                </div>
              </ng-template>
            <span>Выводить сводный результат по подтемам:</span>
          </div>
          <div class='graphs-selected-subject' *ngFor='let file of selectedFiles; let idx = index;'>
            {{idx + 1}}. {{file.str_title}}
          </div>
          <div class='graphs-selected-subject' *ngIf="themes.length == 0 || files.length == 0">
            <mat-progress-spinner
                class="spinner"
                mode="indeterminate">
            </mat-progress-spinner>
          </div>
          <div class='graphs-selected-subject' *ngIf='selectedFiles.length === 0 && themes.length !== 0 && files.length !== 0'>
            Выберите хотя бы одну подтему.
          </div>
        </div>
      </div>
      <div class='graphs graphs-lessons-amount'>
        <span>Кол-во занятий для анализа на графиках</span>
        <select [(ngModel)]="selectedLessonsCount" (change)='updateAllGraphs()'>
          <option *ngFor='let count of lessonCounts' [value]='count.value'>{{count.title}}</option>
        </select>
      </div>
    </ng-container>
    <div class="container not-solving-lesson" *ngIf="allAbsent">
        <h4 style="font-weight: bold; color: #495660;">
          Данные за урок отсутствуют
        </h4>
    </div>
    <app-stat-pagination></app-stat-pagination>
  </div>
</div>
